var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-status",class:_vm.classAndLabel[0]},[_vm._v(" "+_vm._s(_vm.classAndLabel[1])+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }